import Badge from "ds/components/Badge";
import { BadgeVariant } from "ds/components/Badge/types";

type DeprecatedVersionBadgeProps = {
  deprecatedAt: number | null | undefined;
};

const DeprecatedVersionBadge = ({ deprecatedAt }: DeprecatedVersionBadgeProps) => {
  if (!deprecatedAt) {
    return null;
  }

  return <Badge variant={BadgeVariant.red} type="strong" text="Deprecated" />;
};

export default DeprecatedVersionBadge;
